import React, { useCallback, useEffect, useState } from 'react'
//import { Footer } from './components'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
import routes from './app-routes'
import { getHomeRoute, getSafeNextPath } from './utils/navigation.utils'
import { findMenuText } from './utils/admin.utils'
import { RequestPopup, SelectAgrDogovor, SelectDogovor } from "./components";
import { useAuth } from "./contexts/auth";
import { isAdminRoleChecker, isEmployeeRoleChecker } from "./utils/roleChecker";
import { USER_ROLES } from './constants/roles';
import { AdminLayout, UserLayout } from "./layouts";
import './pages/dogovor/dogovor.scss';

const STAFF_PATHS = [ "/admin-panel", "/admin-impersonation" ];
const ADMIN_ONLY_PATHS = [ "/audit", "/audit-stats", "/audit-log", "/admin-maintenance", "/admin-other" ];

const Content = () => {
    const location = useLocation();
    const [ activeRoute, setActiveRoute ] = useState();
    const { countDogovors, dogovors, agrDogovors, navigation, user, selectedDog } = useAuth();
    const [ filterRoutes, setFilterRoutes ] = useState();
    const history = useHistory();
    const isAdmin = isAdminRoleChecker(user, USER_ROLES.ADMIN)
    const isEmployee = isEmployeeRoleChecker(user)
    const isStaff = isAdmin || isEmployee
    const isDogovorPage = location.pathname === '/dogovor'

    useEffect(() => {
        document.documentElement.classList.toggle('dogovor-page-active', isDogovorPage)
        document.body.classList.toggle('dogovor-page-active', isDogovorPage)
        return () => {
            document.documentElement.classList.remove('dogovor-page-active')
            document.body.classList.remove('dogovor-page-active')
        }
    }, [isDogovorPage])

    const Layout = isStaff ? AdminLayout : UserLayout;

    // получаем все пути
    function getAllPaths(data) {
        const paths = [];

        function traverse(items) {
            items?.forEach((item) => {
                if ( item.path ) {
                    paths.push(item.path);
                }
                if ( item.items && item.items.length ) {
                    traverse(item.items);
                }
            });
        }

        traverse(data);
        return paths;
    }

    useEffect(() => {
        (async function () {
            let fr = routes
            if ( countDogovors === 0 && dogovors.length === 0 ) {
                // Админ и сотрудник без договоров должны иметь доступ к страницам своих ролей.
                fr = fr.filter(item =>
                    item.all_users_visible === true ||
                    (isStaff && STAFF_PATHS.includes(item.path)) ||
                    (isAdmin && ADMIN_ONLY_PATHS.includes(item.path))
                )
            }
            let allPaths = getAllPaths(navigation);
            // Пути вне меню БД, но доступные по роли/флагу all_users_visible
            allPaths = [
                '/home',
                ...allPaths,
                '/letters',
                '/profile',
                '/go-isu',
                '/dogovor-actions',
                '/tech-connection',
                '/add-dogovor',
                '/add-dogovor/tat',
                '/edit-dogovor',
                '/terminate-dogovor',
                '/range-volumes-edit',
                '/range-volumes-history',
                '/account-detail',
                '/consumption-analysis',
                '/consumption-history',
                '/admin',
                '/budget', '/budget/add-contract', '/budget/change-contract', '/budget/del-contract',
                '/add-dogovor/ext',
            ]

            // Админ-маршруты: сотруднику — только панель и «Пользователи ЛК», админу — все
            if ( isAdmin ) {
                allPaths = [ ...allPaths, ...STAFF_PATHS, ...ADMIN_ONLY_PATHS ];
            } else if ( isStaff ) {
                allPaths = [ ...allPaths, ...STAFF_PATHS ];
            }

            // all_users_visible не должен отфильтровываться, даже если пункта нет в текущем navigation
            fr = fr.filter(item => allPaths.includes(item.path) || item.all_users_visible === true)
            setFilterRoutes(fr)
        })()
    }, [ countDogovors, dogovors.length, navigation, isAdmin, isStaff ])

    const findTitle = useCallback(
        (path) => findMenuText(navigation, path, selectedDog),
        [ navigation, selectedDog ]
    );

    useEffect(() => {
        //определяем активную страницу
        let newPath = location.pathname;
        let activeRoute = filterRoutes?.find((route) => route.path === newPath);
        if (!activeRoute) {
            const staticRoute = routes.find((route) => route.path === newPath);
            if (staticRoute?.all_users_visible) activeRoute = staticRoute;
        }

    const isAdminOnlyPage = ADMIN_ONLY_PATHS.includes(newPath);
    const isStaffOnlyPage = STAFF_PATHS.includes(newPath);

        if ( isAdminOnlyPage ) {
            // Если пользователь еще не загружен, ждем
            if ( !user ) {
                return;
            }

            const hasAdminRole = isAdminRoleChecker(user, USER_ROLES.ADMIN);

      if (!hasAdminRole) {
        // Если нет роли администратора, редиректим на главную
        newPath = "/home";
        history.push(newPath);
        return;
      }

      // Для админ-страниц не проверяем activeRoute, так как они могут отсутствовать в navigation
      // Просто устанавливаем маршрут напрямую из routes
      if (!activeRoute) {
        const adminRoute = routes.find(route => route.path === newPath);
        if (adminRoute) {
          setActiveRoute(adminRoute);
          document.title = process.env["REACT_APP_TITLE"] + " - " + adminRoute.title;
          history.push(newPath);
        }
      }
    } else if ( isStaffOnlyPage ) {
            if ( !user ) {
                return;
            }

            const hasStaffPageAccess = isAdminRoleChecker(user, USER_ROLES.ADMIN)
                || isEmployeeRoleChecker(user);

            if ( !hasStaffPageAccess ) {
                newPath = "/home";
                history.push(newPath);
                return;
            }

            if (!activeRoute) {
                const staffRoute = routes.find(route => route.path === newPath);
                if (staffRoute) {
                    setActiveRoute(staffRoute);
                    document.title = process.env["REACT_APP_TITLE"] + " - " + staffRoute.title;
                    history.push(newPath);
                }
            }
        }

    setActiveRoute(activeRoute);
    const title = activeRoute?.path ? findTitle(activeRoute?.path) : null;
    //для титла страницы вытягием название из navigation (как в БД забито) а не из app-routes.js
    document.title = activeRoute ? process.env["REACT_APP_TITLE"] + " - " + (title ? title : activeRoute.title) : "ЛКК ЮЛ";

    const nextPath = getSafeNextPath(location.search);

    // После логина URL ещё /login?next=... — возвращаем на исходную страницу
    if (newPath === '/login' && nextPath) {
        history.replace(nextPath);
        return;
    }

    if (!(newPath === '/login') && filterRoutes && location.pathname !== activeRoute?.path) {
        if (!activeRoute) newPath = getHomeRoute(dogovors, selectedDog)
        history.push(newPath);
    }
    /*if (!(newPath === "/login") && filterRoutes && location.pathname !== activeRoute?.path) {
      // Для админ-страниц не делаем редирект, если маршрут не найден в filterRoutes
      const adminOnlyPaths = ["/audit", "/admin", "/admin-panel"];
      if (!activeRoute && !adminOnlyPaths.includes(newPath)) {
        newPath = "/home";
        window.localStorage.setItem("last-path", newPath);
        history.push(newPath);
      }
    }*/
  }, [location, filterRoutes, findTitle, history, user, isAdmin, isStaff, isEmployee, dogovors, selectedDog]);

    return (
        <Layout title={ activeRoute ? activeRoute.title : "ЛКК ЮЛ" }>
            <SelectDogovor visible={ activeRoute ? activeRoute.sd_visible : false }/>
            <SelectAgrDogovor
                visible={
                    activeRoute
                        ? activeRoute.sd_agr_visible && agrDogovors.length > 0
                        : false
                }
            />
            <RequestPopup/>
            <Switch>
                { filterRoutes?.map(({ path, component }) => (
                    <Route exact key={ path } path={ path } component={ component }/>
                )) }
                { filterRoutes && (
                    <Redirect
                        to={
                            (location.pathname === '/login' && getSafeNextPath(location.search))
                            || getHomeRoute(dogovors, selectedDog)
                        }
                    />
                ) }
            </Switch>
            {/*<Footer>*/ }
            {/*  <div className='mt20'>© ООО «ЕЭС-Гарант» - энергосервисная компания №1. *По данным Всероссийского рейтинга РБК</div><br/>*/ }
            {/*    <div className='mt20'>© ООО «ЕЭС-Гарант» - энергосервисная компания №1. *По данным Всероссийского рейтинга РБК</div><br/>*/ }
            {/*    <div className='mt20'>© ООО «ЕЭС-Гарант» - энергосервисная компания №1. *По данным Всероссийского рейтинга РБК</div><br/>*/ }
            {/*    <div className='mt20'>© ООО «ЕЭС-Гарант» - энергосервисная компания №1. *По данным Всероссийского рейтинга РБК</div><br/>*/ }
            {/*    <div className='mt20'>© ООО «ЕЭС-Гарант» - энергосервисная компания №1. *По данным Всероссийского рейтинга РБК</div><br/>*/ }
            {/*</Footer>*/ }
        </Layout>
    );
};

export default Content;
